import React, { useContext } from 'react';

const SurveyContext = React.createContext();

export const useSurveyContext = () => useContext(SurveyContext);

export default SurveyContext;
